var _desc, _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVestElectionsHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "circle-1",
    cx: 25,
    cy: 21,
    r: 21
  }))), /*#__PURE__*/React.createElement("g", {
    id: "02_StockAwards",
    transform: "translate(-3.000000, 1.000000)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#e5f8ed",
    fillRule: "evenodd",
    xlinkHref: "#circle-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#00B550",
    strokeWidth: 1,
    cx: 25,
    cy: 21,
    r: 21.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Pie-1"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#00B550",
    cx: 25,
    cy: 21,
    r: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Slice-1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B550",
    stroke: "#00B550",
    style: {
      strokeWidth: 1
    },
    transform: "matrix(0.203273, 0, 0, 0.203273, -49, -73)",
    d: "M 364 405.966 A 59.034 59.034 0 0 1 415.124943687 435.483 L 364 465 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVestElectionsHover);
export default __webpack_public_path__ + "static/media/vest-elections-hover.dc650d4792f4d502d086147479830f90.svg";
export { ForwardRef as ReactComponent };